import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './FormLabel.css';

function FormLabel(props) {
  return (
    <div
      className={classNames(props.className, 'form-label__container', {
        'form-label__container--center': props.center
      })}
    >
      <span className="form-label__label">{props.children}</span>
      {props.note !== undefined ? (
        <span className="form-label__note">
          <em>{props.note}</em>
        </span>
      ) : null}
    </div>
  );
}

FormLabel.propTypes = {
  children: PropTypes.string,
  center: PropTypes.bool,
  note: PropTypes.string,
  className: PropTypes.string,
  for: PropTypes.string
};

FormLabel.defaultProps = {
  children: '',
  center: false,
  note: undefined,
  className: null
};

export default FormLabel;



// WEBPACK FOOTER //
// ./src/components/form/FormLabel.js